import { FC } from "react";
import { ChatPage } from "../../Chat/views/ChatPage";

export const TalentPage: FC = () => {
  return <ChatPage />;
};
